import { render } from "./DigitalDriverCardsNecessaryDocuments.vue?vue&type=template&id=273bfd1d"
import script from "./DigitalDriverCardsNecessaryDocuments.vue?vue&type=script&lang=js"
export * from "./DigitalDriverCardsNecessaryDocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__